module.exports = __webpack_public_path__ + "assets/img/farming.80b53038.svg";